import { toast, ToastProps } from '@jusbrasil-rc/toast'

type Options = ToastProps & {
  id?: string
}

export function onCopySuccessWithMystiqueToast(message: string, options?: Options): void {
  const { position, className } = options || {}
  toast(message, {
    position: position || 'bottom-right',
    hideProgressBar: true,
    toastId: 'copy-content-trigger-standalone-toast',
    className: `Toast ${className}`,
    autoClose: 7000,
    closeOnClick: true,
    /**
     * This is a hotfix to solve a bug.
     * If it is true users can't select any text
     * while the toast is opened.
     */
    draggable: false,
  })
}
